export const GetCustomerOfferHeaders = (api, offersFilter, cancelToken, pageNumber = -1) => {
    var filters = {
        CustId: offersFilter.custId,
        SiteId: offersFilter.siteId,
        OfferDateFrom: offersFilter.dateFrom,
        OfferDateTo: offersFilter.dateTo,
        InvestmentName: offersFilter.invest,
        SelectedSeller: offersFilter.selectedSeller,
        OrderBy: offersFilter.orderBy,
    }
    return api.post(`/api/v1/Offer/CustomerOfferHeaders?pageNumber=${pageNumber}`, filters, { cancelToken: cancelToken })
}

export const GetRetailerOfferHeaders = (api, offersFilter, cancelToken, pageNumber = -1) => {
    var filters = {
        CustId: offersFilter.custId,
        SiteId: offersFilter.siteId,
        OfferDateFrom: offersFilter.dateFrom,
        OfferDateTo: offersFilter.dateTo,
        InvestmentName: offersFilter.invest,
        SelectedSeller: offersFilter.selectedSeller,
        OrderBy: offersFilter.orderBy,
    }
    return api.post(`/api/v1/Offer/RetailerOfferHeaders?pageNumber=${pageNumber}`, filters, { cancelToken: cancelToken })
}

export const GetRequestOfferHeaders = (api, offersFilter, cancelToken, pageNumber = -1) => {
    var filters = {
        CustId: offersFilter.custId,
        SiteId: offersFilter.siteId,
        OfferDateFrom: offersFilter.dateFrom,
        OfferDateTo: offersFilter.dateTo,
        InvestmentName: offersFilter.invest,
        SelectedSeller: offersFilter.selectedSeller,
        OrderBy: offersFilter.orderBy,
    }
    return api.post(`/api/v1/Offer/RequestOfferHeaders?pageNumber=${pageNumber}`, filters, { cancelToken: cancelToken })
}

export const GetCustomerOfferItems = (api, custId, offerNo, offerSiteId) => {
    return api.get(`/api/v1/Offer/CustomerOfferItems`, {
        params: {
            custId: custId,
            offerNo: offerNo,
            offerSiteId: offerSiteId,
        }
    })
}

export const GetRetailerOfferItems = (api, custId, offerNo, offerSiteId) => {
    return api.get(`/api/v1/Offer/RetailerOfferItems`, {
        params: {
            custId: custId,
            offerNo: offerNo,
            offerSiteId: offerSiteId,
        }
    })
}

export const GetRequestOfferItems = (api, custId, offerNo, offerSiteId) => {
    return api.get(`/api/v1/Offer/RequestOfferItems`, {
        params: {
            custId: custId,
            offerNo: offerNo,
            offerSiteId: offerSiteId,
        }
    })
}

export const GetInvestors = (api, custId) => {
    return api.get(`/api/v1/Offer/GetOfferObject?custId=${custId}`)
}

export const CreateRequestOffer = (api, offerRequest, items, siteId, custId, newInvestor, whId) => {
    return api.post(`/api/v1/Offer/CreateRequestOffer`, createObjectToCreateOfferRequest(false, offerRequest, items, siteId, custId, newInvestor, false, whId))
}

export const CreateRetailerOffer = (api, offerRequest, items, siteId, custId, newInvestor, whId) => {
    return api.post(`/api/v1/Offer/CreateRetailerOffer`, createObjectToCreateOfferRequest(true, offerRequest, items, siteId, custId, newInvestor, false, whId))
}

export const CreateCustomerOffer = (api, offerRequest, items, siteId, custId, newInvestor, isOfferAccepted, whId, requestOfferNo) => {
    return api.post(`/api/v1/Offer/CreateCustomerOffer`, createObjectToCreateOfferRequest(false, offerRequest, items, siteId, custId, newInvestor, isOfferAccepted, whId, requestOfferNo))
}

const createObjectToCreateOfferRequest = (isRetailerOffer, offerRequest, items, siteId, custId, newInvestor, isOfferAccepted, whId, requestOfferNo) => {
    const formattedItems = items.map(item => ({
        ArtNo: item.artNo,
        WhId: whId,
        Qty: item.qty,
        PriceMarkup: isRetailerOffer ? item.retailerMarkup : 0,
        PriceNet: item.costNet,
        ExternalArticle: item.externalArticle ? true : false,
        ArtName: item.product.title,
    }))
    let investorObject = null
    if (!newInvestor.isAdded && !offerRequest.investor) {
        investorObject = null
    }
    else if (newInvestor.isAdded) {
        investorObject = {
            ObjectId: '',
            Name: newInvestor.name,
            ZipCode: newInvestor.zipCode,
            City: newInvestor.city,
            Street: newInvestor.street,
            HouseNum: newInvestor.houseNum,
            LocalNum: newInvestor.localNum,
            ObjectTypeId: newInvestor.objectId.toString(),
            Description: newInvestor.description,
        }
    }
    else {
        investorObject = {
            ObjectId: offerRequest.investor.value.objectId,
            Name: '',
            ZipCode: '',
            City: '',
            Street: '',
            HouseNum: '',
            LocalNum: '',
            ObjectTypeId: '',
            Description: '',
        }
    }
    const dateObj = new Date(offerRequest.expectedDate).toISOString()
    return {
        Header: {
            SiteId: siteId,
            CustId: custId,
            OfferAccepted: isOfferAccepted ? isOfferAccepted : false,
            InvestmentObject: investorObject,
            ContactPerson: offerRequest.investName,
            ExpirationDate: dateObj,
            Comments: offerRequest.additionalInfo,
            TotalPriceMarkup: isRetailerOffer ? offerRequest.totalPriceMarkup : -1,
            ServiceNetValue: isRetailerOffer ? offerRequest.serviceNetValue : -1,
            ServiceTaxRate: isRetailerOffer ? offerRequest.retailerTax : -1,
            requestOfferNo: requestOfferNo && requestOfferNo != 'null' ? requestOfferNo : null,
        },
        Items: formattedItems
    }
}

export const GetInvestorsTypes = (api) => {
    return api.get('/api/v1/Offer/GetOfferObjectType')
}

export const GetCustomerOfferPdf = (api, custId, offerId, offerSiteId) => {
    return api.get(`/api/v1/Offer/GetCustomerOfferPdf`, {
        params: {
            custId: custId,
            offerId: offerId,
            offerSiteId: offerSiteId,
        },
        responseType: 'blob'
    })
}

export const GetRetailerOfferPdf = (api, custId, offerId, offerSiteId, withUnitPrice) => {
    return api.get(
        `/api/v1/Offer/GetRetailerOfferPdf?custId=${custId}&offerId=${offerId}&offerSiteId=${offerSiteId}&withUnitPrice=${withUnitPrice}`,
        {
            responseType: 'blob'
        }
    )
}

export const GetBasketForAcceptedOffer = (api, custId, offerNo, offerSiteId, whId) => {
    return api.get(`/api/v1/Offer/GetBasketForAcceptedOffer?custId=${custId}&offerNo=${offerNo}&offerSiteId=${offerSiteId}&whId=${whId}`)
}

export const GetAvailabilityForAkceptedOffer = (api, akceptedOffer, whId) => {
    return api.post(`/api/v1/Offer/getAvailabilityForAkceptedOffer?whId=${whId}`, akceptedOffer)
}

export const GetSavedOffer = (api, custId, whId, siteId, mode, offerId) => {
    let tmpOfferId = offerId ? offerId : -1
    return api.get(`/api/v1/Offer/GetSavedOffer?custId=${custId}&whId=${whId}&siteId=${siteId}&mode=${mode}&offerId=${tmpOfferId}`)
}

export const CreateUpdateSavedOffer = (api, mode, offerRequest, products, isPh, offerExpiredDate) => {
    let items = products.map((p, index) => ({
        OfferPosition: index,
        ArtNo: p.artNo,
        RetailerMarkup: p.retailerMarkup ? p.retailerMarkup : p.priceMarkup,
        Qty: isNaN(p.qty) ? 0 : p.qty,
        PriceNet: p.costNet,
        ExternalArticle: p.externalArticle,
        ExternalArticleProductName: p.externalArticle ? p.product.title : '',
    }))
    const dateObj = new Date(offerRequest.expectedDate).toISOString()
    let data = {
        TaxRate: offerRequest.retailerTax,
        Investor: offerRequest.investName,
        ExpectedDate: dateObj,
        AdditionalInfo: offerRequest.additionalInfo,
        Mode: mode,
        isPh: isPh,
        Items: items,
        OfferExpiredDate: offerExpiredDate,
    }
    return api.post('/api/v1/Offer/CreateUpdateSavedOffer', data)
}

export const DeleteSavedOffer = (api, mode) => {
    return api.delete(`/api/v1/Offer/DeleteSavedOffer?mode=${mode}`)
}

export const GetCurrentSavedOfferId = (api, mode) => {
    return api.get(`/api/v1/Offer/GetCurrentSavedOfferId?mode=${mode}`)
}

export const AddUpdateProductToSavedOffer = (api, product, quantity, offerId) => {
    var data = {
        OfferId: offerId,
        ArtNo: product.index,
        Qty: quantity,
        RetailerMarkup: 0,
        PriceNet: product.priceNet,
        ExternalArticle: false,
        ExternalArticleProductName: ''
    }
    return api.post(`/api/v1/Offer/AddUpdateProductToSavedOffer`, data)
}

export const CreateUpdateSavedOfferInvestObject = (api, mode, investorObject) => {
    var data = {
        ObjectId: investorObject.objectId ? investorObject.objectId : -1,
        ObjectTypeId: investorObject.objectTypeId ? investorObject.objectTypeId : -1,
        InvestName: investorObject.name ? investorObject.name : '',
        Street: investorObject.street ? investorObject.street : '',
        LocalNo: investorObject.localNum ? investorObject.localNum : '',
        HouseNo: investorObject.houseNum ? investorObject.houseNum : '',
        City: investorObject.city ? investorObject.city : '',
        ZipCode: investorObject.zipCode ? investorObject.zipCode : '',
        InvestDesc: investorObject.description ? investorObject.description : ''
    }
    return api.post(`/api/v1/Offer/CreateUpdateSavedOfferInvestObject?mode=${mode}`, data)
}

export const GetSavedOfferInvestObject = (api, mode) => {
    return api.get(`/api/v1/Offer/GetSavedOfferInvestObject?mode=${mode}`)
}

export const DeleteRetailerOffer = (api, custId, offerNo, offerSiteId) => {
    return api.delete(`/api/v1/Offer/DeleteRetailerOffer?custId=${custId}&offerNo=${offerNo}&offerSiteId=${offerSiteId}`)
}

export const GetOfferFiltersData = (api, offerCurrentView, offersFilter, cancelToken) => {
    return api.post(`/api/v1/Offer/GetOfferFiltersData?offerType=${offerCurrentView}`, offersFilter, { cancelToken: cancelToken })
}

export const GetNumberOfUnreadCustomerOffer = (api, custId, cancelToken) => {
    var filters = {
        CustId: custId,
        SiteId: '',
        OfferDateFrom: null,
        OfferDateTo: null,
        InvestmentName: '',
        OfferNo: '',
        UserId: '',
        OrderBy: 0,
    }
    return api.post(`/api/v1/Offer/GetNumberOfUnreadCustomerOffer`, filters, { cancelToken: cancelToken })
}

export const ChangeOfferStatus = (api, custId, offerNo, offerSiteId, cancelToken) => {
    return api.post(`/api/v1/Offer/changeOfferStatus?custId=${custId}&offerSiteId=${offerSiteId}&requestOfferNo=${offerNo}`, null, { cancelToken: cancelToken })
}

export const GetCustomerOffer = (api, offerNo, custId, offerSiteId) => {
    return api.get(`/api/v1/Offer/getCustomerOffer?offerNo=${offerNo}&custId=${custId}&offerSiteId=${offerSiteId}`)
}

export const GetCustomerOfferRequest = (api, requestNo, custId, requestSiteId) => {
    return api.get(`/api/v1/Offer/getCustomerOfferRequest`, {
        params: {
            requestNo,
            custId,
            requestSiteId,
        }
    })
}

export const GetBasketForAcceptedOfferWithVoucher = (api, custId, offerNo, offerSiteId, whId, voucher, products) => {
    let data = products.map(item => {
        return {
            userId: item.userId,
            artNo: item.artNo,
            custId: item.custId,
            qty: item.qty,
            costNet: item.costNet,
            costGross: item.costGross,
            totalCost: item.totalCost,
            totalCostGross: item.totalCostGross,
            currency: item.currency,
            isSelected: item.isSelected,
            product: item.product,
            retailerMarkup: item.retailerMarkup || 0,
            externalArticle: item.externalArticle || false,
            discount: item.discount,
            addToBasketDate: item.addToBasketDate,
            offerNo: item.offerNo,
            offerSiteId: item.offerSiteId
        }
    })
    return api.post(`/api/v1/Offer/getBasketForAcceptedOfferWithVoucher?custId=${custId}&offerNo=${offerNo}&offerSiteId=${offerSiteId}&whId=${whId}&voucher=${voucher}`, data)
}